/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'
export type DeviceEnrollmentDeviceInfo = {
	deviceModel?: string | null
	platform?: string
	platformVersion?: string | null
	appVersion?: string
	nativeBuildVersion?: string | null
	androidId?: string | null
}

export const zDeviceEnrollmentDeviceInfo = z.object({
	deviceModel: z.string().optional().nullable(),
	platform: z.string().optional(),
	platformVersion: z.string().optional().nullable(),
	appVersion: z.string().optional(),
	nativeBuildVersion: z.string().optional().nullable(),
	androidId: z.string().optional().nullable()
})
